<template>
  <div class="step-container" @click.stop>
    <AiNavComponent v-model="curCommentType" />
    <div class="step-wrapper" v-show="curCommentType == 0">
      <div class="step-flex-1">
        <div class="step-flex-content">
          <!-- 餐卡点评 -->
          <div class="title">
            {{ titleList[active]
            }}<span class="s-step">（{{ active + 1 }}/3）</span>
          </div>
          <div class="step-flex">
            <div class="step-content" ref="scroll">
              <div ref="content">
                <StepComponent
                  class="step-component"
                  :active="active"
                ></StepComponent>
                <StepOne v-show="active == 0" :data="data" />
                <StepTwo
                  v-show="active == 1"
                  :data="data"
                  :labelData="data && data.labelData"
                  ref="step2"
                />
                <StepThree
                  ref="step3"
                  v-if="value && active == 2"
                  :active="active"
                  :data="data"
                  :labelData="data && data.labelData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <StepBtns
        class="step-btn"
        v-model="active"
        @save="bindSave"
        @release="bindRelease"
        @previous="bindPrevious"
        @next="bindNext"
      />
    </div>
    <div class="step-wrapper" v-show="curCommentType == 1">
      <div class="step-scroll">
        <!-- ai点评 -->
        <AiComment v-show="curCommentType == 1" :data="dietData.ai_data" />
      </div>
    </div>
  </div>
</template>
<script>
import StepComponent from './step-component.vue'
import StepOne from './step-one.vue'
import StepTwo from './step-two.vue'
import StepThree from './step-three.vue'
import StepBtns from './step-btns.vue'
import AiNavComponent from './ai-nav.vue'
import AiComment from './ai-comment.vue'
export default {
  components: {
    StepComponent,
    StepOne,
    StepTwo,
    StepThree,
    StepBtns,
    AiNavComponent,
    AiComment
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dietData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      active: 0,
      curCommentType: 0,
      titleList: ['餐卡评分', '餐卡点评', '发布点评'],
      reviewLoaded: false, //开头结束语等是否更新过一次
      dietReviewLoaded: false, //饮食分析是否更新过一次
      scoreUpdate: false //评分是否更新
    }
  },
  watch: {
    active() {
      this.$emit('change', this.active)
      //只要当前步骤是第二部并且 没有加载过一次默认评分内容或者评分更新了
      if (
        this.active == 1 &&
        this.dietData.p_type == 7 &&
        (!this.dietReviewLoaded || this.scoreUpdate)
      ) {
        this.getDietReviewData()
      }
      if (this.active == 1) {
        // this.$parent.getReviewData(1, 'opening_words')
        // this.$parent.getReviewData(2, 'end_words')
        // this.$parent.getReviewData(3, 'future_dietary_analysis')
      }
      this.initRadar()
      this.$nextTick(() => {
        this.$refs.scroll.scrollTop = 0
      })
    },
    value(val) {
      if (val) {
        this.active = this.$parent.data.active || 0
      }
      this.initRadar()
    }
  },
  created() {
    this.active = this.$parent.data.active || 0
    this.computedScore(this.data.scoreData)
  },
  methods: {
    initRadar() {
      if (this.active == 2 && this.value) {
        this.$refs.step3 && this.$refs.step3.initRadar()
      }
    },
    bindcatch() {},
    bindSave() {
      this.$emit('save')
    },
    bindRelease() {
      this.$emit('release')
    },
    bindPrevious() {
      this.active = this.active > 0 ? this.active - 1 : 0
    },
    bindNext() {
      if (this.active == 1 && !this.checkLabel()) {
        return
      }
      if (this.active == 1 && !this.checkInput()) {
        return
      }
      this.active++
    },
    //检查优缺点是否选择一个
    checkLabel() {
      let res = true
      let selectindex = 0
      let labelList = ['优点', '缺点']
      this.data.labelData.map((item, index) => {
        if (labelList.includes(item.name)) {
          item.list.map((item1, index1) => {
            if (item1.checked) {
              selectindex++
            }
          })
        }
      })
      if (!selectindex) {
        this.$toast('优点或缺点至少选择一项')
        res = false
      }
      return res
    },
    //检查输入框
    checkInput() {
      //检查点评内容
      for (let i = 0; i < this.data.reviewData.length; i++) {
        let item = this.data.reviewData[i]
        if (
          item.minlength &&
          (item.value === '' || item.value.length < item.minlength)
        ) {
          this.$toast(item.name + '不能少于' + item.minlength + '个字')
          return false
        }
      }
      //检查未来建议
      let dietaryAdvice = this.data.dietaryAdvice
      if (
        dietaryAdvice.minlength &&
        (dietaryAdvice.value === '' ||
          dietaryAdvice.value.length < dietaryAdvice.minlength)
      ) {
        this.$toast(
          dietaryAdvice.name + '不能少于' + dietaryAdvice.minlength + '个字'
        )
        return false
      }
      //检查异常描述
      if (this.data.exceptionDesc) {
        let exceptionDesc = this.data.exceptionDesc
        if (
          exceptionDesc.minlength &&
          (exceptionDesc.value === '' ||
            exceptionDesc.value.length < exceptionDesc.minlength)
        ) {
          this.$toast(
            exceptionDesc.name + '不能少于' + exceptionDesc.minlength + '个字'
          )
          return false
        }
      }
      return true
    },
    //计算分数
    computedScore(data) {
      data.map((item, index) => {
        let score = item.maxScore
        item.list.map((item1, index1) => {
          if (item1.index >= 0) {
            score += item1.select[item1.index].less
          }
        })
        item.score = score
      })
      return data
    },
    //获取饮食分享默认文案
    getDietReviewData() {
      let params = {
        pid: this.$route.query.pid,
        p_type: this.dietData.p_type,
        curMeal: this.$route.query.curMeal,
        unify_id: this.dietData.unify_id,
        postion_type: 1,
        p_staple_weight_type: this.getScoreIndex('staple', 'weight'),
        p_protein_weight_type: this.getScoreIndex('protein', 'weight'),
        p_vegetable_weight_type: this.getScoreIndex('vegetable', 'weight'),
        p_grease_weight_type: this.getScoreIndex('grease', 'weight'),
        p_taste_type: this.getScoreIndex('taste', 'type')
      }
      this.$http
        .getApp('member/NutritionistComments/getLabelComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = res.data
            this.data.reviewData.map((item) => {
              let str = item.val.split('_')[0] || ''
              if (data[str] !== undefined) {
                item.value = data[str] || ''
              }
            })
          }
          this.scoreUpdate = false
          this.dietReviewLoaded = true
        })
    },
    getScoreIndex(name, type) {
      for (let i = 0; i < this.data.scoreData.length; i++) {
        let item = this.data.scoreData[i]
        if (item.val == name) {
          for (let j = 0; j < item.list.length; j++) {
            let item1 = item.list[j]
            if (item1.type == type) {
              return item1.index + 1
            }
          }
        }
      }
    },
    //获取开启结束等点评内容默认文案
    getReviewData(type, val) {
      let params = {
        addtime: this.dietData.addtime,
        pid: this.$route.query.pid,
        p_type: this.dietData.p_type,
        curMeal: this.$route.query.curMeal,
        unify_id: this.dietData.unify_id,
        postion_type: type
      }
      this.$http
        .getApp('member/NutritionistComments/getAllCommentRecommend', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data) {
              this.data.reviewData.map((item) => {
                if (item.val == val) {
                  item.value = res.data
                }
              })
              //饮食建议
              if (this.data.dietaryAdvice.val == val) {
                this.data.dietaryAdvice.value = res.data
              }
            } else {
              this.$toast('没有可换的文案啦!')
            }
          }
          this.reviewLoaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.step-container {
  border-radius: 12px 12px 0px 0px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 63%;
  background-color: #f9f9f9;
  padding-top: 17px;
  padding: 17px 20px;
  box-sizing: border-box;
  animation: mymove 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .step-wrapper {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    .step-flex-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
    .step-flex-1 {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }
    .step-scroll {
      height: 100%;
      overflow-y: scroll;
    }
  }
  .title {
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 25px;
    margin-bottom: 4px;
    .s-step {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }
  }
  .step-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .step-content {
      height: 100%;
      overflow-y: scroll;
      .step-component {
        width: 215px;
        margin: 20px auto 20px;
      }
      .review-content {
        background: #ffffff;
        border-radius: 12px;
        padding: 20px 0px;
      }
    }
  }
  .step-btn {
    margin-top: 16px;
  }
}
@keyframes mymove {
  0% {
    height: 0%;
  }
  100% {
    height: 63%;
  }
}
</style>
